// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"f87f0946","2201":"52e8a12a","6040":"f87f0946"}[chunkId] + ".chunk.css";
};